import CrudApi from './crud';

export const crud = new CrudApi('/admin/educations', {
	only: ['index'],
});
